import React from "react"
import { NumericKeys } from "../../../core/services/helper-service"
import { BSMaterialResultDashboard } from "../../../core/dto/beem-shot/BSMaterialResult/BSMaterialResultDashboard"
import { RowBarChart } from "./RowBarChart"

interface IProps {
  maxValue: number
  minValue: number
  fieldName: NumericKeys<BSMaterialResultDashboard>
  bsMaterialResult: BSMaterialResultDashboard
  isSelected: boolean
}

export function RowMaterialResultBarChart({
  bsMaterialResult,
  fieldName,
  maxValue,
  minValue,
  isSelected,
}: Readonly<IProps>): React.JSX.Element {
  return (
    <RowBarChart
      maxValue={maxValue}
      minValue={minValue}
      value={bsMaterialResult[fieldName]}
      lot={bsMaterialResult.lot}
      isSelected={isSelected}
    />
  )
}
